import type { ReactNode } from "react";
import { Grid } from "@mui/material";
import type { TransfertCEA } from "models";
import EauAssGepuSousCompetencesAccordion from "components/Informations/SousCompetences/EauAssGepuSousCompetencesAccordion";
import { useDisplayDates } from "hooks";
import { usePerimetreSansTerritoiresTransfertsGrouping } from "pages/Perimetre/hooks/usePerimetreTransfertsGrouping";
import PerimetreSansTerritoirePorteesAccordionSummary from "./PerimetreSansTerritoirePorteesAccordionSummary";

interface PerimetreSansTerritoireEauAssGepuSousCompetencesProps {
  transferts: Array<TransfertCEA>;
}

function PerimetreSansTerritoireEauAssGepuSousCompetences({
  transferts,
}: Readonly<PerimetreSansTerritoireEauAssGepuSousCompetencesProps>): ReactNode {
  const { isDisplayingDates } = useDisplayDates();
  const currentGroupedTransferts = usePerimetreSansTerritoiresTransfertsGrouping(
    transferts,
    isDisplayingDates
  );

  return (
    <Grid container spacing={2} size={12}>
      {currentGroupedTransferts.map((transfertsByCommune) => (
        <EauAssGepuSousCompetencesAccordion
          key={`${transfertsByCommune[0]?.[0]?.lieuParticulier?.id}${transfertsByCommune[0]?.[0]?.entiteTransferante?.id}`}
          defaultExpanded={currentGroupedTransferts.length === 1}
          transferts={transfertsByCommune[0]}
          summary={
            <PerimetreSansTerritoirePorteesAccordionSummary
              entiteTransferante={transfertsByCommune[0]?.[0]?.entiteTransferante}
              lieuParticulier={transfertsByCommune[0]?.[0]?.lieuParticulier}
            />
          }
        />
      ))}
    </Grid>
  );
}

export default PerimetreSansTerritoireEauAssGepuSousCompetences;
